import React, { useState } from 'react';
import Header from '../Header';
import { useParams } from 'react-router-dom';
import axios from 'axios';

const Communication = () => {
  const { id } = useParams(); // lead_id
  const [watiChecked, setWatiChecked] = useState(false);
  const [smsChecked, setSmsChecked] = useState(false);
  const [selectedTemplate, setSelectedTemplate] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [alertType, setAlertType] = useState(''); // 'success' or 'danger'


 const handleSubmit = async () => {
  if (!watiChecked && !smsChecked) {
    setAlertType('danger');
    setMessage('Please select at least one communication method.');
    return;
  }

  if ((watiChecked || smsChecked) && !selectedTemplate) {
    setAlertType('danger');
    setMessage('Please select a template.');
    return;
  }

  setLoading(true);
  setAlertType('');
  setMessage('');

  try {
    // WATI API call
    if (watiChecked) {
      const watiData = {
        templateName: selectedTemplate,
        broadcastName: selectedTemplate,
      };

      const watiResponse = await axios.post(
        `https://apiaksharaconnect.aksharafinalytics.in/sendwati/${id}`,
        watiData
      );

      console.log('WATI Response:', watiResponse.data);
    }

    // SMS API call
    if (smsChecked) {
      const smsData = {
        templateName: selectedTemplate,
      };

      const smsResponse = await axios.post(
        `https://apiaksharaconnect.aksharafinalytics.in/leadindiviualsms/${id}`,
        smsData
      );

      console.log('SMS Response:', smsResponse.data);
    }

    setAlertType('success');
    setMessage('Message(s) sent successfully.');
  } catch (error) {
    console.error('API Error:', error.response?.data || error.message);
    setAlertType('danger');
    setMessage('An error occurred while sending messages.');
  } finally {
    setLoading(false);
  }
};



  return (
    <>
      <Header />

      <div className="container mt-5">
        <div className="card shadow">
          <div className="card-header">
            <h2>Communication</h2>
          </div>

          <div className="card-body">
            {/* Wati checkbox */}
            <div className="form-check mb-3">
              <input className="form-check-input" type="checkbox" id="watiCheckbox" checked={watiChecked} onChange={() => setWatiChecked(!watiChecked)}/>
              <label className="form-check-label" htmlFor="watiCheckbox">
                Wati
              </label>
            </div>

            {/* Template dropdown */}
            {watiChecked && (
              <div className="mb-3">
                <label htmlFor="templateSelect" className="form-label">
                  Select Template
                </label>
                <select className="form-select" id="templateSelect" value={selectedTemplate} onChange={(e) => setSelectedTemplate(e.target.value)}>
                  <option value="">-- Select Template --</option>
                  <option value="initial_contact">Initial Contact</option>
                  <option value="inquiry_response">Initial Response</option>
                  <option value="offers">Offers</option>
                  <option value="request_appointment">Request Appointment</option>
                  <option value="followup_msg">followup msg</option>
                  <option value="quotation_request">Quotation Request</option>
                </select>
              </div>
            )}

            {/* SMS checkbox */}
            { <div className="form-check mb-3">
              <input  className="form-check-input" type="checkbox" id="smsCheckbox" checked={smsChecked} onChange={() => setSmsChecked(!smsChecked)}/>
              <label className="form-check-label" htmlFor="smsCheckbox">
                SMS
              </label>
            </div> }

            {smsChecked && (
              <div className="mb-3">
                <label htmlFor="templateSelect" className="form-label">
                  Select Template
                </label>
                <select className="form-select" id="templateSelect" value={selectedTemplate} onChange={(e) => setSelectedTemplate(e.target.value)}>
                  <option value="">-- Select Template --</option>
                  <option value="initial_contact">Initial Contact</option>
                  <option value="inquiry_response">Initial Response</option>
                  <option value="offers">Offers</option>
                  <option value="request_appointment">Request Appointment</option>
                  <option value="followup_msg">followup msg</option>
                  <option value="quotation_request">Quotation Request</option>
                </select>
              </div>
            )}

            {/* Submit Button */}
            <button
              className="btn btn-primary"
              onClick={handleSubmit}
              disabled={loading}
            >
              {loading ? 'Sending...' : 'Submit'}
            </button>

            {/* Response Message */}
            {message && (
                <div className={`mt-3 alert alert-${alertType}`} role="alert">
                    {message}
                </div>
            )}

          </div>
        </div>
      </div>
    </>
  );
};

export default Communication;
